// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import SocialMedias from '../components/SocialMedias';
import {actions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    error: state.generalConfig.error,
    isSaving: state.socialMediasConfig.isSaving,
    savingSuccess: state.socialMediasConfig.savingSuccess,
    socialMedias: state.information.socialMedia,
    isFetchingSocial: state.information.isFetchingSocial,
    socialMediaTypes: state.information.socialMediaTypes,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(SocialMedias);
